import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestImageAiDescriptionCreateOrTranslate } from '@shared/dto/+image/image_ai_description/_requests/request_image_ai_description_create_or_translate';
import { DTOImageAiDescription } from '@shared/dto/+image/image_ai_description/dto_image_ai_description';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { STATE__images } from './STATE__images';

export const remote_images_ai_description_translate = createAsyncThunkSafe<DTOImageAiDescription, RequestImageAiDescriptionCreateOrTranslate[]>(
  ENUM__network_event_client_to_server.IMAGES_AI_DESCRIPTION_TRANSLATE,
  async (requests: RequestImageAiDescriptionCreateOrTranslate[]) => {
    return await send_to_server(ENUM__network_event_client_to_server.IMAGES_AI_DESCRIPTION_TRANSLATE, requests);
  },
);

export function init_remote_images_ai_description_translate(builder: ActionReducerMapBuilder<STATE__images>) {
  builder
    .addCase(remote_images_ai_description_translate.pending, (state, action) => {
      for (let request of action.meta.arg) {
        let key = get_key(request.image_id, request.language);

        state.ai_descriptions_translation_in_progress.add(key);
      }

      //need to force rerender
      state.ai_descriptions_translation_in_progress = new Set(state.ai_descriptions_translation_in_progress);
    })
    .addCase(remote_images_ai_description_translate.rejected, (state, action) => {})
    .addCase(remote_images_ai_description_translate.fulfilled, (state, action: PayloadAction<DTOImageAiDescription[]>) => {
      for (let response of action.payload) {
        let key = get_key(response.image_id, response.language);

        state.ai_descriptions_translation_in_progress.delete(key);
      }

      //need to force rerender
      state.ai_descriptions_translation_in_progress = new Set(state.ai_descriptions_translation_in_progress);
    });
}

function get_key(image_id: string, language: string): string {
  return `${image_id}_${language}`;
}
